'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getFirstTemplate = function getFirstTemplate(message) {
  return message.metadata.richMediaTemplates.first();
};

exports.default = getFirstTemplate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/operators/chat-rich-template/getFirstTemplate.js
// module id = 542
// module chunks = 2 3